import { type RouteLocation } from 'vue-router';

export const statelessRoutes = [
  {
    path: '/account',
    redirect: { name: 'account.login' },
    name: 'account',
    meta: {
      requires: {
        user: false,
        project: false,
      },
    },
    component: () => import('./AccountIndex.vue'),
    children: [
      {
        path: '',
        name: 'account.login.index',
        meta: {
          layout: 'blank',
        },
        component: () => import('./AccountLoginIndex.vue'),
        children: [
          {
            path: '/login',
            name: 'account.login',
            meta: {
              title: 'Login',
              layout: 'blank',
              search: {
                show: false,
              },
            },
            component: () => import('./AccountLoginPage.vue'),
            props: (route: RouteLocation) => ({
              email: route.query.email,
            }),
          },
          {
            path: '/register',
            name: 'account.register',
            meta: {
              title: 'Register',
              layout: 'blank',
              requireProject: false,
              search: {
                show: false,
              },
            },
            component: () => import('./AccountRegisterPage.vue'),
            props: (route: RouteLocation) => ({
              email: route.query.email,
            }),
          },
          {
            path: '/reset-password',
            name: 'account.reset-password',
            meta: {
              title: 'Reset Password',
              layout: 'blank',
              search: {
                show: false,
              },
            },
            component: () => import('./AccountResetPasswordPage.vue'),
          },
          {
            path: '/unsubscribed',
            name: 'account.preference-unsubscribed',
            meta: {
              title: 'Preference Unsubscribed',
              layout: 'blank',
              search: {
                show: false,
              },
            },
            component: () => import('./PreferenceUnsubscribe.vue'),
          },
        ],
      },
      {
        path: '/forgotten-password',
        name: 'account.forgotten-password',
        meta: {
          title: 'Forgotten Password',
          layout: 'blank',
          requires: {
            user: false,
            project: false,
          },
          search: {
            show: false,
          },
        },
        component: () => import('./AccountForgottenPasswordPage.vue'),
      },
      {
        path: '/set-password',
        name: 'account.set-password',
        meta: {
          title: 'Set Password',
          layout: 'blank',
          search: {
            show: false,
          },
        },
        component: () => import('./AccountSetPasswordPage.vue'),
      },
    ],
  },
];

export const routes = [
  {
    name: 'account.index',
    path: '/settings',
    meta: {
      layout: 'standard',
      requires: {
        user: true,
        project: false,
      },
      requireProject: false,
    },
    children: [
      {
        path: '',
        name: 'account.settings',
        meta: {
          layout: 'standard',
          requireProject: false,
          title: 'Settings',
          description: 'Manage your account settings',
          breadcrumbs: [{ name: 'account.settings' }],
          search: {
            show: true,
            title: 'Account Settings',
          },
        },
        component: () => import('./SettingsPage.vue'),
      },
      {
        path: 'change-password',
        name: 'account.settings.change-password',
        meta: {
          layout: 'standard',
          requireProject: false,
          title: 'Change Password',
          breadcrumbs: [{ name: 'account.settings' }, { name: 'account.settings.change-password' }],
          search: {
            show: true,
          },
        },
        component: () => import('./ChangePasswordPage.vue'),
      },
      {
        path: 'two-factor-authentication',
        redirect: { name: 'account.settings.2fa.setup-authenticator' },
        name: 'account.settings.2fa',
        meta: {
          layout: 'standard',
          requireProject: false,
          title: 'Two Factor Authentication',
          breadcrumbs: [{ name: 'account.settings' }, { name: 'account.settings.2fa' }],
          search: {
            show: false,
          },
        },
        children: [
          {
            path: 'setup-authenticator',
            name: 'account.settings.2fa.setup-authenticator',
            meta: {
              layout: 'standard',
              requireProject: false,
              title: 'Setup Authentication App',
              breadcrumbs: [
                { name: 'account.settings' },
                { name: 'account.settings.2fa' },
                { name: 'account.settings.2fa.setup-authenticator' },
              ],
              search: {
                show: true,
              },
            },
            component: () => import('./2FAAuthenticatorSetupPage.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/device',
    name: 'account.device',
    meta: {
      layout: 'fullscreen',
      requires: {
        user: true,
        project: false,
      },
      requireProject: false,
    },
    component: () => import('./DeviceAuthorizePage.vue'),
  },
];
